import React from "react"
import styled from "styled-components"
import { theme } from "@op-str/op-component-library"

export const SectionTitle = styled.div`
  padding: 48px 0 30px 0;
  font-size: ${theme.fontSize.xl};
  font-weight: bold;
`
